import React from 'react';
import { Dialog } from '@material-ui/core';
import { Button, ButtonGroup } from 'reactstrap';
import Draggable from 'react-draggable';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
// import '../Shared/Css/empPople.css'

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function EmpPopleDetail(props) {

  const styleDialogTitle = {
    position: 'absolute',
    color: 'white',
    fontSize: '0.85rem',
    margin: 0,
    right: '0',
    float: "center",
    zIndex: '10',  //z-index 겹침부분인덱스 기본갑은 0 이다
  }
  const handleClose = (e) => {
    props.setEmpPopleDetailTrue(false);
  };

  return (
    <div className='bothsize'>
      <Dialog open={props.empPopleDetailTrue} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title" >
        <DialogTitle style={styleDialogTitle}>
          <ButtonGroup
            id='draggable-dialog-title'
            size="small"
          >
            <Button color="danger" outline style={{ cursor: 'move', marginRight: '2px' }}>이동</Button>
          </ButtonGroup>
          <Button color="danger" outline onClick={handleClose} >닫기</Button>
        </DialogTitle>
        <video
          style={{ margin: 'auto', verticalAlign: 'baseline' }}
          controls
          preload="auto"
          autoPlay
          // playstart='flase'
          width="100%"
          height="auto"
          data-setup="{}"
        >
          <source src={props.videoValue} />
        </video>
      </Dialog>
    </div>
  )
}

export default EmpPopleDetail